import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { importModalAtom } from '@/atoms/import';
import { Button } from '@/components/ui/button';

export const ImportScriptRulesButton = () => {
    const { t } = useTranslation();
    const setImportModal = useSetAtom(importModalAtom);

    return (
        <Button
            variant="text"
            className="p-0 gap-1.5 underline h-auto leading-none"
            startIcon={<HelpOutlineIcon />}
            onClick={() =>
                setImportModal(prev => ({
                    ...prev,
                    showRules: true,
                    showStatistics: false,
                    showCharacters: false,
                }))
            }
            children={t('import.rules')}
        />
    );
};
